// src/context/GlobalProvider.jsx
import React from "react";
import { AdminProvider } from "./contextAdmin";
import { AuthProvider } from "./contextAuth";
import { PaymentProvider } from "./contextPayment";
import { ProfileProvider } from "./contextProfile";
import { ThemeProvider } from "./contextTheme";
import { DesignProvider } from "./contextDesign";
import { ChatProvider } from "./contextChat";
import { WSProvider } from "./contextNotify";

export const GlobalProvider = ({ children }) => {
  const providers = [
    AdminProvider,
    AuthProvider,
    PaymentProvider,
    ProfileProvider,
    ThemeProvider,
    DesignProvider,
    ChatProvider,
    WSProvider,
  ];

  return providers.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    children
  );
};